export const Arr_PhysicalHealthInfo = [
  //-------------------------------------------------------------------------
  //Physical Health

  // Start Mobility Aids
  //question [3]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Mobility aids",
    name: "PhysicalHealth_mobility_aids",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student use any mobility aids, or are they a wheelchair user
      </p>
    ),
  },
  //question [4]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Please tell us more",
    name: "PhysicalHealth_mobility_aids_select",
    selectValues: [
      "Mobility aids (such as crutches, walking frame, cane, stick)",
      "Wheelchair user (manual)",
      "Wheelchair  user (electric)",
      "Other",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_mobility_aids_select_specify",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_select",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Is the student able to independently use their mobility aids/ wheelchair",
    name: "PhysicalHealth_mobility_aids_independently_use",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "If the student is a wheelchair user, are they able to get in and out of their chair independently",
    name: "PhysicalHealth_mobility_aids_independently_get_in_out",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Support needs",
    name: "PhysicalHealth_mobility_aids_how_much_support",
    selectValues: [
      "Student will need daily support with their mobility",
      "Student will sometimes need support with their mobility, they are developing some independence",
      "Student will need occasional support with their mobility, they are mostly independent",
      "Student is unlikely to need any support with their mobility, they are very independent",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
    AboveText: (
      <p>
        How much support will the student need day-to-day regarding their
        mobility? Please be aware that InvestIN cannot provide personal care
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_mobility_aids_support_explained",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
    AboveText: (
      <p>
        Please provide practical details for what this support could look like
        for the student (e.g. might occasionally need help to sit and rest)
      </p>
    ),
  },
  // Mobility Aids Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "PhysicalHealth_mobility_aids_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_mobility_aids_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_mobility_aids_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_mobility_aids_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_mobility_aids_prescribed_medication_storage_requirements",
  },
  // Mobility Aids Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_mobility_aids_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
    AboveText: (
      <p>
        Has the student had a serious incident related to their mobility and
        required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_mobility_aids_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_mobility_aids_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_mobility_aids_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_mobility_aids_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        mobility
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_mobility_aids_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s mobility, such as any other access needs that the student
        would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_mobility_aids_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_mobility_aids_anything_else",
  },
  //question [57]
  // End Mobility Aids
  // start visual impairment
  //question [58]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Visual impairment",
    name: "PhysicalHealth_visual_impairment",
    selectValues: [
      "Yes",
      "No",
      "Yes – wears glasses or contact lenses, no additional support required",
    ],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student have a visual impairment or is registered blind? Please
        note, that if the student wears glasses/ contact lenses and no
        additional support is needed please indicate below
      </p>
    ),
  },
  //question [59]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Sit at front",
    name: "PhysicalHealth_visual_impairment_sit_at_front",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment",
    AboveText: (
      <p>
        Would sitting at the front of the room during programme delivery be
        helpful for the student (where available)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Support needs",
    name: "PhysicalHealth_visual_impairment_select",
    selectValues: [
      "Student will need daily support due to visual impairment",
      "Student will sometimes need support due to visual impairment, they are developing some independence",
      "Student will need occasionally need support due to visual impairment, they are mostly independent",
      "Student is unlikely to need any support due to visual impairment they are very independent",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment",
    AboveText: (
      <p>
        How much support will the student need day-to-day regarding their
        vision? Please be aware that InvestIN cannot provide any personal care.
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide information",
    name: "Please specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment",
    AboveText: (
      <p>
        Please provide practical details for what this support could look like
        for the student (e.g. might occasionally need help to sit and rest)
      </p>
    ),
  },
  // visual impairment Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "PhysicalHealth_visual_impairment_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_visual_impairment_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_visual_impairment_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_visual_impairment_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_visual_impairment_prescribed_medication_storage_requirements",
  },
  // visual impairment Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_visual_impairment_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_serious_incident",
    AboveText: (
      <p>
        Has the student had a serious incident related to their condition and
        required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_visual_impairment_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_visual_impairment_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_visual_impairment_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_visual_impairment_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        visual impairment
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_visual_impairment_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s visual impairment, such as any other access needs that the
        student would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_visual_impairment_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_visual_impairment_anything_else",
    // End visual impairment
  },
  // start hearing impairment
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the student deaf or hard of hearing",
    name: "PhysicalHealth_hearing_impairment",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Hearing impairment",
    name: "PhysicalHealth_hearing_impairment_sit_at_front",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment",
    AboveText: (
      <p>
        Would sitting at the front of the room during programme delivery be
        helpful for the student (where available)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Hearing loop",
    name: "PhysicalHealth_hearing_impairment_hearing_loop",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment",
    AboveText: (
      <p>Will the student use a hearing loop during programme delivery</p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Printed information",
    name: "PhysicalHealth_hearing_impairment_printed_information",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment",
    AboveText: (
      <p>
        Would the student benefit from having printed information for each day
        made available to them? (Where possible)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Mobility aids",
    name: "PhysicalHealth_hearing_impairment_select",
    selectValues: [
      "Student will need daily support due to hearing impairment",
      "Student will sometimes need support due to hearing impairment, they are developing some independence",
      "Student will need occasionally need support due to hearing impairment, they are mostly independent",
      "Student is unlikely to need any support due to hearing impairment they are very independent",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment",
    AboveText: (
      <p>
        How much support will the student need day-to-day regarding their
        vision? Please be aware that InvestIN cannot provide any personal care.
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "PhysicalHealth_hearing_impairment_support_explained",
    name: "Please specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment",
    AboveText: (
      <p>
        Please provide practical details for what this support could look like
        for the student (e.g. might occasionally need help to sit and rest)
      </p>
    ),
  },
  // hearing impairment Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. 2 drops per ear)",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_hearing_impairment_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_hearing_impairment_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_hearing_impairment_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_hearing_impairment_prescribed_medication_storage_requirements",
  },
  // hearing impairment Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_hearing_impairment_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_serious_incident",
    AboveText: (
      <p>
        Has the student had a serious incident related to their condition and
        required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_hearing_impairment_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_hearing_impairment_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_hearing_impairment_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_hearing_impairment_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        hearing impairment
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_hearing_impairment_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s hearing impairment, such as any other access needs that the
        student would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_hearing_impairment_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_hearing_impairment_anything_else",
  },
  //question [85]
  // End hearing impairment

  // start asthma
  //question [86]

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have asthma",
    name: "PhysicalHealth_asthma",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //question [87]

  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How severe is their asthma day to day",
    name: "PhysicalHealth_asthma_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma",
  },

  // asthma Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have a prescription for an inhaler(s)",
    name: "PhysicalHealth_asthma_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_asthma_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: (
      <p>
        If yes, all students with asthma registered on their student enrolment
        form must carry their inhaler(s) or medicine at all times. Please tell
        us about the student’s inhaler by completing the questions below for
        each type of inhaler (e.g. if the student uses two inhalers, complete
        the questions separately for each inhaler):
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_asthma_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_asthma_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Instructions (e.g. use in the morning/ evening or only when needed)",
    name: "PhysicalHealth_asthma_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_asthma_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_asthma_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_asthma_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_asthma_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_asthma_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_asthma_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_asthma_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_asthma_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_asthma_prescribed_medication_storage_requirements",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Self administer",
    name: "PhysicalHealth_asthma_prescribed_medication_self_administer",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_medication",
    AboveText: (
      <p>
        Is the student able to self-administer their inhaler/ medication when
        required
      </p>
    ),
  },
  //asthma Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "PhysicalHealth_asthma_prescribed_triggers ",
    selectValues: [
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_specific_medicines",
        label: "Specific medicines (such as anti-inflammatory painkillers)",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_changes_in_weather",
        label: "Changes in weather or cold, damp weather",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_cough_cold_flu",
        label: "Cough, cold, flu",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_allergies",
        label: "Allergies (such as pollen, animals, or dust mites)",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_smoke_fumes_pollution",
        label: "Smoke, fumes, pollution",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_stress_anxiety",
        label: "Stress or anxiety",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_mould_damp",
        label: "Mould or damp",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_exercise",
        label: "Exercise",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_citrus_fruits",
        label: "Citrus fruits (when consumed)",
      },
      {
        name: "PhysicalHealth_asthma_prescribed_triggers_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma",
    SpecialCondition: "Optional",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_asthma_prescribed_triggers_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_prescribed_triggers_other",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_asthma_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_serious_incident",
    AboveText: (
      <p>
        Has the student had a serious incident related to their condition and
        required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the asthma attack",
    name: "PhysicalHealth_asthma_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent asthma attack",
    name: "PhysicalHealth_asthma_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_asthma_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_serious_incident",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_asthma_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s asthma
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_asthma_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_asthma_anything_else",
  },
  //question [110]
  // End asthma
  // start epilepsy
  //question [111]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have epilepsy",
    name: "PhysicalHealth_epilepsy",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student have{" "}
        <a href="https://www.nhs.uk/conditions/epilepsy/" target="_blank">
          <strong>epilepsy</strong>
        </a>{" "}
        or a history of seizures (including absence seizures?)
      </p>
    ),
  },
  //question [112]

  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label:
      "If the student has a seizure, how severe would this be for the student",
    name: "PhysicalHealth_epilepsy_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_epilepsy_severity_how_often",
    selectValues: [
      "The student has not had a seizure in the last 12 months",
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
    AboveText: (
      <p>
        How often has the student experienced a seizure within the last 12
        months
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was this their first seizure",
    name: "PhysicalHealth_epilepsy_first_time",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_severity_how_often",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "If the student has a seizure, what are the triggers for a seizure (if known)",
    name: "PhysicalHealth_epilepsy_triggers",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent seizure",
    name: "PhysicalHealth_epilepsy_most_recent_when",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "How long did the seizure last (approximately)",
    name: "PhysicalHealth_epilepsy_most_recent_how_long",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Did the student have multiple seizures",
    name: "PhysicalHealth_epilepsy_most_recent_muiltiple_seizures",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Did the student lose consciousness during the seizure",
    name: "PhysicalHealth_epilepsy_most_recent_lose_consciousness",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Was the student injured during the seizure",
    name: "PhysicalHealth_epilepsy_most_recent_injured",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Did the student have difficulty breathing during the seizure",
    name: "PhysicalHealth_epilepsy_most_recent_difficulty_breathing",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_epilepsy_most_recent_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Will the student usually be aware if they are about to have a seizure (and could therefore safely get themself to the floor)",
    name: "PhysicalHealth_epilepsy_student_awareness",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },

  // epilepsy Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have a prescription for their epilepsy",
    name: "PhysicalHealth_epilepsy_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_epilepsy_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: (
      <p>
        If yes, all students with epilepsy registered on their student enrolment
        form must carry their inhaler(s) or medicine at all times. Please tell
        us about the student’s inhaler by completing the questions below for
        each type of inhaler (e.g. if the student uses two inhalers, complete
        the questions separately for each inhaler):
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_epilepsy_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_epilepsy_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What times",
    name: "PhysicalHealth_epilepsy_prescribed_medication_times",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: (
      <p>
        What time should the student take this medication? (e.g. 9am and 6pm)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "PhysicalHealth_epilepsy_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Instructions (e.g. use in the morning/ evening or only when needed)",
    name: "PhysicalHealth_epilepsy_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_epilepsy_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Are there any side effects we should be aware of",
    name: "PhysicalHealth_epilepsy_prescribed_medication_side_effects",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_epilepsy_prescribed_medication_side_effects_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication_side_effects",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_epilepsy_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_epilepsy_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_epilepsy_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_epilepsy_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_epilepsy_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_epilepsy_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_epilepsy_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_epilepsy_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_epilepsy_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_epilepsy_prescribed_medication_storage_requirements",
  },
  //epilepsy Medication end

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_epilepsy_steps_to_take",
    selectValues: [
      "If residential, return them to their bedroom to sleep",
      "If non-residential, call the nominated contact to collect them from the programme so they can return home to sleep",
      "Other",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
    AboveText: (
      <p>
        If the student had a seizure during their time with InvestIN, we would
        always follow medical protocols to care for the student and check on
        them regularly. Following a seizure and medical support provided, what
        steps would you like us to take to support the student
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_epilepsy_steps_to_take_other_specify",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_steps_to_take",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_epilepsy_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s epilepsy or seizure history
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_epilepsy_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_epilepsy_anything_else",
  },

  //question [146]
  // End epilepsy

  // start diabetes
  //question [147]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have diabetes",
    name: "PhysicalHealth_diabetes",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student have{" "}
        <a href="https://www.nhs.uk/conditions/diabetes/" target="_blank">
          <strong>diabetes</strong>
        </a>{" "}
      </p>
    ),
  },
  //question [148]
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "When was the student diagnosed with diabetes",
    name: "PhysicalHealth_diabetes_diagnosed",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "Impact on day-to-day",
    name: "PhysicalHealth_diabetes_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
    AboveText: (
      <p>
        what impact does their diabetes have on their day-to-day? (e.g. if the
        student regularly experiences hypoglycaemia/ hyperglycaemia please
        indicate according to the colour coding)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student use a wearable glucose monitor",
    name: "PhysicalHealth_diabetes_glucose_monitor",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the student able to independently review their blood sugar",
    name: "PhysicalHealth_diabetes_independently_review_blood_sugar",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Is the student self-aware of sugar intake and proactive with their eating habits",
    name: "PhysicalHealth_diabetes_self_aware_sugar_intake",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Please tell us the student’s normal blood sugar range (e.g. between 4-7 after meals)",
    name: "PhysicalHealth_diabetes_normal_blood_sugar_range",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Please tell us about the student’s insulin and what support they may need. We will have a sharps bin available if required",
    name: "PhysicalHealth_diabetes_insulin_support",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student use an auto-insulin pump",
    name: "PhysicalHealth_diabetes_auto_insulin_pump",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the insulin pump connected to the student’s phone",
    name: "PhysicalHealth_diabetes_auto_insulin_pump_phone_connected",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_auto_insulin_pump",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the student able to self-administer their insulin when required",
    name: "PhysicalHealth_diabetes_auto_insulin_pump_self_administer",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_auto_insulin_pump",
  },

  // diabetes Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student take any medication (other than insulin) for their diabetes",
    name: "PhysicalHealth_diabetes_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_diabetes_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_diabetes_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_diabetes_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "PhysicalHealth_diabetes_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Instructions (e.g. use in the morning/ evening or only when needed)",
    name: "PhysicalHealth_diabetes_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_diabetes_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_diabetes_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_diabetes_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_diabetes_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_diabetes_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_diabetes_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_diabetes_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_diabetes_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_diabetes_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_diabetes_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_diabetes_prescribed_medication_storage_requirements",
  },
  //diabetes Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "PhysicalHealth_diabetes_signs",
    selectValues: [
      {
        name: "PhysicalHealth_diabetes_signs_thirsty",
        label: "Feeling very thirsty",
      },
      {
        name: "PhysicalHealth_diabetes_signs_needing_to_urinate",
        label: "Needing to urinate more often",
      },
      {
        name: "PhysicalHealth_diabetes_signs_blurred_vision",
        label: "Stomach pain",
      },
      {
        name: "PhysicalHealth_diabetes_signs_blurred_vision",
        label: "Feeling sick or being sick",
      },
      {
        name: "PhysicalHealth_diabetes_signs_blurred_vision",
        label: "Diarrhoea",
      },
      {
        name: "PhysicalHealth_diabetes_signs_breathing_deeply",
        label: "Breathing more deeply than usual",
      },
      {
        name: "PhysicalHealth_diabetes_signs_breath_smells_fruity",
        label:
          "Breath that smells fruity (like pear drop sweets or nail polish remover)",
      },
      {
        name: "PhysicalHealth_diabetes_signs_drowsy",
        label: "Feeling tired, sleepy or confused",
      },
      {
        name: "PhysicalHealth_diabetes_signs_blurred_vision",
        label: "Blurred vision",
      },
      {
        name: "PhysicalHealth_diabetes_signs_flushed_face",
        label: "Flushed face",
      },
      {
        name: "PhysicalHealth_diabetes_signs_sweating",
        label: "Sweating",
      },
      {
        name: "PhysicalHealth_diabetes_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is feeling unwell due to their diabetes, what signs
        should we look out for? Please select all that apply.
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_diabetes_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_signs_other",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "PhysicalHealth_diabetes_hypo_crisis",
    selectValues: [
      {
        name: "PhysicalHealth_diabetes_hypo_crisis_hypoglycaemia",
        label: "Yes - hypoglycaemia",
      },
      {
        name: "PhysicalHealth_diabetes_hypo_crisis_hyperglycaemia",
        label: "Yes - hyperglycaemia",
      },
      {
        name: "PhysicalHealth_diabetes_hypo_crisis_no",
        label: "No",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        Has the student experienced hypoglycaemia, hyperglycaemia or a diabetic
        crisis and required emergency medical treatment in the last 12 months?
        (e.g. usual intervention methods were not successful in raising/
        lowering the students' blood sugar)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_diabetes_hypo_crisis_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: ["Yes"],
    withRegardsTo: "PhysicalHealth_diabetes_hypo_crisis_no",
    AboveText: (
      <p>
        If yes to either of the above, please tell us typically how often this
        has occurred in the last 12 months
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_diabetes_hypo_crisis_trigger",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: ["Yes"],
    withRegardsTo: "PhysicalHealth_diabetes_hypo_crisis_no",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "When was the most recent diabetic incident that required emergency medical care",
    name: "PhysicalHealth_diabetes_hypo_crisis_most_recent",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: ["Yes"],
    withRegardsTo: "PhysicalHealth_diabetes_hypo_crisis_no",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_diabetes_hypo_crisis_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: ["Yes"],
    withRegardsTo: "PhysicalHealth_diabetes_hypo_crisis_no",
  },
  //
  //
  //

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_diabetes_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s diabetes
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_diabetes_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_diabetes_anything_else",
  },
  //question [182]
  // End diabetes

  // start sickle_cell_disease
  //question [183]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have sickle cell disease",
    name: "PhysicalHealth_sickle_cell_disease",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //question [184]
  {
    Page: "PhysicalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "PhysicalHealth_sickle_cell_disease_symptoms",
    selectValues: [
      {
        name: "PhysicalHealth_sickle_cell_disease_symptoms_tiredness",
        label: "Tiredness/ fatigue",
      },
      {
        name: "PhysicalHealth_sickle_cell_disease_symptoms_muscle_pains",
        label: "Muscle aches/ pains",
      },
      {
        name: "PhysicalHealth_sickle_cell_disease_symptoms_targeted_pain",
        label: "Targeted pain (such as hands, arms, legs, lower back)",
      },
      {
        name: "PhysicalHealth_sickle_cell_disease_symptoms_anaemia",
        label: "Anaemia",
      },
      {
        name: "PhysicalHealth_sickle_cell_disease_symptoms_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        What are the day-to-day symptoms that might impact the student as a
        result of their sickle cell disease?
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_sickle_cell_disease_symptoms_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_symptoms_other",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "What impact does this have on their day-to-day",
    name: "PhysicalHealth_sickle_cell_disease_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease",
  },
  // sickle_cell_disease Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student take any medication (other than insulin) for their sickle cell disease",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_sickle_cell_disease_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_sickle_cell_disease_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_sickle_cell_disease_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_sickle_cell_disease_prescribed_medication_storage_requirements",
  },
  //sickle_cell_disease Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_sickle_cell_disease_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease",
    AboveText: (
      <p>
        Has the student had a serious sickle cell-related incident and required
        urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_sickle_cell_disease_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_sickle_cell_disease_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_sickle_cell_disease_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_sickle_cell_disease_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their sicle
        cell disease
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_sickle_cell_disease_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s sickle cell disease, such as any other access needs that the
        student would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_sickle_cell_disease_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_sickle_cell_disease_anything_else",
  },
  //question [208]
  // End sickle_cell_disease

  // start migraines
  //question [209]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student experience migraines",
    name: "PhysicalHealth_migraines",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //question [210]
  {
    Page: "PhysicalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "PhysicalHealth_migraines_symptoms",
    selectValues: [
      {
        name: "PhysicalHealth_migraines_symptoms_thrrobbing_pain",
        label: "Throbbing pain in one or both sides of the head",
      },
      {
        name: "PhysicalHealth_migraines_symptoms_light_sounds",
        label: "Sensitivity to light or sounds",
      },
      {
        name: "PhysicalHealth_migraines_symptoms_visual_changes",
        label: "Vision changes",
      },
      {
        name: "PhysicalHealth_migraines_symptoms_nausea",
        label: "Nausea",
      },
      {
        name: "PhysicalHealth_migraines_symptoms_vomiting",
        label: "Vomiting",
      },
      {
        name: "PhysicalHealth_migraines_symptoms_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines",
    SpecialCondition: "Optional",
    AboveText: (
      <p>What are the symptoms of the student experiencing a migraine</p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_migraines_symptoms_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_symptoms_other",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_migraines_how_often",
    selectValues: [
      "•The student has not had a migraine in the last 12 months",
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_serious_incident",
    AboveText: (
      <p>Typically, how often does the student experience migraines</p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "What impact does this have on their day-to-day",
    name: "PhysicalHealth_migraines_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines",
    AboveText: (
      <p>
        What impact does this have on their day-to-day (if they are experiencing
        a migraine)
      </p>
    ),
  },
  // migraines Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student take any medication related to their migraines",
    name: "PhysicalHealth_migraines_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_migraines_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_migraines_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_migraines_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_migraines_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "PhysicalHealth_migraines_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_migraines_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_migraines_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_migraines_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_migraines_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_migraines_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_migraines_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_migraines_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_migraines_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_migraines_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_migraines_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_migraines_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_migraines_prescribed_medication_storage_requirements",
  },
  //migraines Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_migraines_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines",
    AboveText: (
      <p>
        Has the student had a serious migraine-related incident and required
        urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_migraines_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_migraines_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_migraines_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_migraines_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        migraines
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_migraines_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s migraines, such as any other access needs that the student
        would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_migraines_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_migraines_anything_else",
  },
  //question 235
  // End migraines
  // start haemophilia
  //question [236]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student experience haemophilia",
    name: "PhysicalHealth_haemophilia",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //question [237]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "What impact does this have on their day-to-day",
    name: "PhysicalHealth_haemophilia_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia",
    AboveText: <p>What impact does this have on their day-to-day</p>,
  },
  // haemophilia Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student take any medication related to their haemophilia",
    name: "PhysicalHealth_haemophilia_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_haemophilia_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_haemophilia_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_haemophilia_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_haemophilia_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "PhysicalHealth_haemophilia_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_haemophilia_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_haemophilia_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_haemophilia_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_haemophilia_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_haemophilia_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_haemophilia_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_haemophilia_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_haemophilia_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_haemophilia_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_haemophilia_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_haemophilia_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_haemophilia_prescribed_medication_storage_requirements",
  },
  //haemophilia Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_haemophilia_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia",
    AboveText: (
      <p>
        Has the student had a serious haemophilia-related incident and required
        urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_haemophilia_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_haemophilia_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_haemophilia_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_haemophilia_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        haemophilia
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_haemophilia_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s haemophilia, such as any other access needs that the student
        would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_haemophilia_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_haemophilia_anything_else",
  },
  //question [259]
  // End haemophilia

  // start heart_condition
  //question [260]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any heart conditions",
    name: "PhysicalHealth_heart_condition",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //question [261]
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us about the student’s specific heart condition",
    name: "PhysicalHealth_heart_condition_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "What impact does this have on their day-to-day",
    name: "PhysicalHealth_heart_condition_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition",
    AboveText: <p>What impact does this have on their day-to-day</p>,
  },
  // heart_condition Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student take any medication related to their heart condition",
    name: "PhysicalHealth_heart_condition_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_heart_condition_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_heart_condition_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_heart_condition_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_heart_condition_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "PhysicalHealth_heart_condition_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_heart_condition_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_heart_condition_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_heart_condition_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_heart_condition_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_heart_condition_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_heart_condition_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_heart_condition_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_heart_condition_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_heart_condition_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_heart_condition_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_heart_condition_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_heart_condition_prescribed_medication_storage_requirements",
  },
  //heart_condition Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_heart_condition_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition",
    AboveText: (
      <p>
        Has the student had a serious heart condition-related incident and
        required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_heart_condition_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_heart_condition_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_heart_condition_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_heart_condition_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their heart
        condition
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_heart_condition_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s heart condition, such as any other access needs that the
        student would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_heart_condition_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_heart_condition_anything_else",
  },
  //question [284]
  // End heart_condition

  // start other_physical_condition
  //question [285]
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have any other physical conditions",
    name: "PhysicalHealth_other_physical_condition",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //question [286]
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Please tell us about the student’s specific other physical condition",
    name: "PhysicalHealth_other_physical_condition_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "What impact does this have on their day-to-day",
    name: "PhysicalHealth_other_physical_condition_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition",
    AboveText: <p>What impact does this have on their day-to-day</p>,
  },
  // other_physical_condition Medication start

  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student take any medication related to their other physical condition",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication_interact_badly",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication_anything_else",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_other_physical_condition_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "PhysicalHealth_other_physical_condition_prescribed_medication_storage_requirements",
  },
  //other_physical_condition Medication end
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "PhysicalHealth_other_physical_condition_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition",
    AboveText: (
      <p>
        Has the student had a serious other physical condition-related incident
        and required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "PhysicalHealth_other_physical_condition_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "PhysicalHealth_other_physical_condition_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Did the student need to attend hospital",
    name: "PhysicalHealth_other_physical_condition_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition_serious_incident",
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Frequency",
    name: "PhysicalHealth_other_physical_condition_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their other
        condition
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "PhysicalHealth_other_physical_condition_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s physical condition, such as any other access needs that the
        student would need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "PhysicalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "PhysicalHealth_other_physical_condition_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "PhysicalHealth_other_physical_condition_anything_else",
  },
  //question [309]
  // End other_physical_condition
];
